import { Component, ChangeDetectionStrategy } from '@angular/core'
import { FacilityContextDirective } from '../../../context/facility-context/facility-context.directive'
import { WorkOrderBrowserComponent } from '../work-order-browser/work-order-browser.component'
import { FacilityContextMenuComponent } from '../../../context/facility-context/facility-context-menu/facility-context-menu.component'
import {
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
  ElderToolbarColumnDirective,
} from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-work-order-browser-viewer',
  templateUrl: './work-order-browser-viewer.component.html',
  styleUrls: ['./work-order-browser-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ElderToolbarColumnDirective,
    FacilityContextMenuComponent,
    WorkOrderBrowserComponent,
    FacilityContextDirective,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class WorkOrderBrowserViewerComponent {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}
}
